import React, { ReactElement, useEffect, useRef } from "react"
import Prism from "prismjs"
import "prismjs/components/prism-bash"

function Shell({ code }: any): ReactElement {
  const preRef = useRef<HTMLPreElement | null>(null)

  useEffect(() => {
    Prism.highlightElement(preRef.current as Element)
  }, [])

  return (
    <>
      <pre ref={preRef} className="language-bash relative z-0">
        <code>{code}</code>
      </pre>
    </>
  )
}

export default Shell
